<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <h1 class="title">{{ supplier.name }}</h1>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row info-cards__row--dotted">
            <span>Total Ordered:</span><span>{{ supplier.orders_ordered.toLocaleString() }} TSh</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Total Unpaid:</span><span>{{ supplier.orders_unpaid.toLocaleString() }} TSh</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Total Paid:</span><span>{{ supplier.orders_paid.toLocaleString() }} TSh</span>
          </div>
        </div>
        <div class="info-cards__card">
          <div class="info-cards__row info-cards__row--dotted">
            <span>Invoice Missing:</span><span>{{ supplier.orders_invoice_missing.toLocaleString() }}</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>EFD Provided:</span><span>{{ supplier.orders_efd_provided.toLocaleString() }} TSh</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>EFD Missing:</span><span>{{ supplier.orders_efd_missing.toLocaleString() }} TSh</span>
          </div>
        </div>
        <div class="info-cards__card">
          <div class="info-cards__row info-cards__row--dotted">
            <span>Unpaid orders:</span><span>{{ supplier.count_unpaid_orders.toLocaleString() }}</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Orders by bank:</span><span>{{ supplier.orders_by_bank.toLocaleString() }}</span>
          </div>
          <div class="info-cards__row info-cards__row--dotted">
            <span>Orders by cash:</span><span>{{ supplier.orders_by_cash.toLocaleString() }}</span>
          </div>
        </div>
      </div>
      <div class="accordion accordion--640">
        <button @click="show_info = !show_info" class="accordion__header" :class="{ 'accordion__header--show': show_info }">
          <span class="accordion__title">Supplier information</span>
        </button>
        <transition name="slide-small">
          <div v-if="show_info" class="accordion__body">
            <form class="accordion__form" @submit.prevent="onCheckForm">
              <div class="accordion__row accordion__row--type-300">
                <app-form-group label="Name" label-for="supplier_name" required>
                  <app-input
                    v-model="form.name"
                    id="supplier_name"
                    placeholder="Name"
                    name="supplier_name"
                    :error="$v.form.name.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.name.$dirty && !$v.form.name.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Payment method" required>
                  <app-select
                    v-model="form.payment_method"
                    :options="payment_method_options"
                    :clearable="false"
                    placeholder="Payment method"
                    :error="$v.form.payment_method.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.payment_method.$dirty && !$v.form.payment_method.required">Required field</div>
                  </template>
                </app-form-group>
              </div>
              <app-cells :indent="false" position="end">
                <app-button ref="submit_info" type="submit">Save</app-button>
              </app-cells>
            </form>
          </div>
        </transition>
      </div>
      <template v-if="table_orders_bank.items.length">
        <app-cells>
          <h2 class="title">Orders by Bank</h2>
          <app-filters
            v-model="filter"
            :filters="filters"
            name="filterHall"
            @change="onFilterChange"
          />
        </app-cells>
        <v-client-table
          :data="table_orders_bank.items"
          :columns="table_orders_bank.columns"
          :options="table_orders_bank.options"
          class="table-default"
          :class="{ 'table-default--loading': table_bank_preloader }"
        >
          <template #h__select>
            <label
              v-if="table_orders_bank.items.filter(item => !item.is_paid && item.status.code === 'completed').length"
              class="checkbox checkbox--table"
            >
              <input
                v-model="checked_all"
                type="checkbox"
                name="checked_all"
                ref="mainCh"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #select="{ row }">
            <label v-if="!row.is_paid && row.status.code === 'completed'" class="checkbox  checkbox--table">
              <input
                v-model="checked"
                type="checkbox"
                :value="row.id"
                :name="row.id"
              />
              <span class="checkbox__checkmark"></span>
            </label>
          </template>
          <template #h__id><div class="table-default__left">ID</div></template>
          <template #id="{ row }">
            <router-link class="table-default__link-border" :to="{name: 'product-storage-order-detail', params: {id: row.id }}">
              Order - {{ row.id }}
            </router-link>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.status.color || '#8a8a8a' }">
            {{ row.status.name }}
          </span>
          </template>
          <template #is_paid="{ row }">
          <span
            class="table-default__colored"
            :class="{ 'table-default__colored--green': row.is_paid, 'table-default__colored--red': !row.is_paid }"
          >
            {{ row.is_paid ? 'Paid' : 'Not paid' }}
          </span>
          </template>
          <template #invoice.file="{ row }">
            <div class="table-default__controls">
              <button
                v-if="row.invoice && row.invoice.file"
                @click="onDownloadInvoice(row.invoice, row.id)"
                type="button"
              >
                <img src="@/assets/img/download-table-blue-icon.svg" alt="">
              </button>
              <button v-else type="button" disabled><img src="@/assets/img/not-check-red-icon.svg" alt=""></button>
            </div>
          </template>
          <template #date="{ row }">{{ dateFormat(row.date) }}</template>
          <template #real="{ row }">{{ row.real.toLocaleString() }} TSh</template>
          <template #efd_provided="{ row }">{{ row.efd_provided.toLocaleString() }} TSh</template>
          <template #efd_missing="{ row }">{{ row.efd_missing.toLocaleString() }} TSh</template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationOrderBank"
              v-if="pagination_orders_bank.pages > 1"
              v-model="pagination_orders_bank.page"
              :page-count="pagination_orders_bank.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_orders_bank.count" :count="table_orders_bank.items.length" :page="pagination_orders_bank.page" />
        </app-cells>
      </template>
      <template v-if="table_orders_payments.items.length">
        <app-cells><h2 class="title">Payments by Bank</h2></app-cells>
        <v-client-table
          :data="table_orders_payments.items"
          :columns="table_orders_payments.columns"
          :options="table_orders_payments.options"
          class="table-default"
          :class="{ 'table-default--loading': table_payments_preloader }"
        >
          <template #date="{ row }">{{ dateFormat(row.date) }}</template>
          <template #bank="{ row }">{{ row.bank ? row.bank.name : '' }}</template>
          <template #amount="{ row }">{{ row.amount.toLocaleString() }} TSh</template>
          <template #orders="{ row }">
          <span v-tooltip="{ content: orderList(row.orders), placement: 'top-start', offset: 10, html: true }">
            {{ row.orders.length }}
          </span>
          </template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationPayments"
              v-if="pagination_orders_payments.pages > 1"
              v-model="pagination_orders_payments.page"
              :page-count="pagination_orders_payments.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_orders_payments.count" :count="table_orders_payments.items.length" :page="pagination_orders_payments.page" />
        </app-cells>
      </template>
      <template v-if="table_orders_cash.items.length">
        <app-cells><h2 class="title">Orders by Cash</h2></app-cells>
        <v-client-table
          :data="table_orders_cash.items"
          :columns="table_orders_cash.columns"
          :options="table_orders_cash.options"
          class="table-default"
          :class="{ 'table-default--loading': table_cash_preloader }"
        >
          <template #h__id><div class="table-default__left">ID</div></template>
          <template #id="{ row }">
            <router-link class="table-default__link-border" :to="{name: 'product-storage-order-detail', params: {id: row.id }}">
              Order - {{ row.id }}
            </router-link>
          </template>
          <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.status.color || '#8a8a8a' }">
            {{ row.status.name }}
          </span>
          </template>
          <template #date="{ row }">{{ dateFormat(row.date) }}</template>
          <template #real="{ row }">{{ row.real.toLocaleString() }} TSh</template>
          <template #efd_provided="{ row }">{{ row.efd_provided.toLocaleString() }} TSh</template>
          <template #efd_missing="{ row }">{{ row.efd_missing.toLocaleString() }} TSh</template>
        </v-client-table>
        <app-cells position="between">
          <div>
            <paginate
              :clickHandler="onClickPaginationOrderCash"
              v-if="pagination_orders_cash.pages > 1"
              v-model="pagination_orders_cash.page"
              :page-count="pagination_orders_cash.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
            />
          </div>
          <app-table-records :all="pagination_orders_cash.count" :count="table_orders_cash.items.length" :page="pagination_orders_cash.page" />
        </app-cells>
      </template>
      <app-cells><h2 class="title">Products</h2></app-cells>
      <v-client-table
          :data="table_products.items"
          :columns="table_products.columns"
          :options="table_products.options"
          class="table-default"
          :class="{ 'table-default--loading': table_product_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
                to=""
                class="table-default__link-border"
            >
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #recommended_balance="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.recommended_balance) }}</template>
        <template #in_stock="{ row }">{{ new Intl.NumberFormat('ru-RU', {minimumFractionDigits: 1}).format(row.in_stock) }}</template>
        <template #status="{ row }">
          <span class="status-tag" :style="{ 'backgroundColor': row.status.color || '#8a8a8a' }">
            {{ row.status.name }}
          </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
              :clickHandler="onClickPaginationProduct"
              v-if="pagination_products.pages > 1"
              v-model="pagination_products.page"
              :page-count="pagination_products.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_products.count" :count="table_products.items.length" :page="pagination_products.page" />
      </app-cells>
    </template>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected orders: <span>{{ checked.length }}</span></div>
      <app-button @click.native="$modal.show('create-payment')">Make payment</app-button>
    </div>
    <modal
        name="create-payment"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('create-payment')" class="popup__close" type="button"></button>
        <div class="popup__title">Make payment to supplier</div>
        <div class="popup__body">
          <form>
            <app-form-group label="Bank" required>
              <app-select
                v-model="payment_bank"
                :options="bank_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Bank"
                :error="$v.payment_bank.$error"
              />
              <template #error>
                <div v-if="$v.payment_bank.$dirty && !$v.payment_bank.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Note" label-for="note">
              <app-textarea
                v-model="payment_note"
                id="note"
                placeholder="If you wish, write a note on the payment"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button @click.native="onPaymentCreate" :disabled="$v.payment_bank.$error" ref="submit">Make payment</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getBanks,
  getOrdersProduct,
  getPaymentMethods,
  getProductsProductstorage,
  getSupplierPayments,
  getSupplierProduct,
  patchProductStorageSupplier,
  postSupplierPayments,
} from '@/http'
import { format, parse } from 'date-fns'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'SupplierDetail',
  data() {
    return {
      is_loaded: false,
      supplier: {},
      table_orders_bank: {
        items: [],
        columns: ['select', 'id', 'status', 'is_paid', 'invoice.file', 'date', 'real', 'efd_provided', 'efd_missing'],
        options: {
          headings: {
            'select': '',
            'id': 'ID',
            'status': 'Status',
            'is_paid': 'Payment status',
            'invoice.file': 'Invoice',
            'date': 'Date',
            'real': 'Order value',
            'efd_provided': 'EFD provided',
            'efd_missing': 'EFD missing',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_orders_bank: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_orders_payments: {
        items: [],
        columns: ['date', 'bank', 'amount', 'orders', 'note'],
        options: {
          headings: {
            date: 'Date',
            bank: 'Bank',
            amount: 'Amount',
            orders: 'Orders',
            note: 'Note',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_orders_payments: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_orders_cash: {
        items: [],
        columns: ['id', 'status', 'date', 'real', 'efd_provided', 'efd_missing'],
        options: {
          headings: {
            'id': 'ID',
            'status': 'Status',
            'date': 'Date',
            'real': 'Order value',
            'efd_provided': 'EFD provided',
            'efd_missing': 'EFD missing',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_orders_cash: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_products: {
        items: [],
        columns: ['name', 'measurement.name', 'recommended_balance', 'in_stock', 'status'],
        options: {
          headings: {
            'name': 'Product name',
            'measurement.name': 'Unit',
            'recommended_balance': 'Recomm. Balance',
            'in_stock': 'Current Stock',
            'status': 'Status',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_products: {
        pages: 1,
        page: 1,
        count: 1,
      },
      filter: '',
      filters: [
        { value: '', label: 'All' },
        { value: 'true', label: 'Paid' },
        { value: 'false', label: 'Unpaid' },
      ],
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      payment_note: '',
      payment_bank: '',
      show_info: false,
      form: {},
      payment_method_options: [],
      bank_options: [],
      table_bank_preloader: false,
      table_cash_preloader: false,
      table_product_preloader: false,
      table_payments_preloader: false,
    }
  },
  validations: {
    form: {
      name: { required },
      payment_method: { required },
    },
    payment_bank: { required },
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table_orders_bank.items.forEach(item => {
          if (!item.is_paid && !this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    document.title = `Supplier (ID: ${ this.$route.params.id }) | Altezza Board`
    Promise.all([
      getSupplierProduct(this.$route.params.id),
      getOrdersProduct({ page: 1, page_size: 20, supplier: this.$route.params.id, payment_method: 'bank' }),
      getOrdersProduct({ page: 1, page_size: 20, supplier: this.$route.params.id, payment_method: 'cash' }),
      getProductsProductstorage({ page: 1, page_size: 20, suppliers: [this.$route.params.id] }),
      getSupplierPayments(this.$route.params.id, { page: 1, page_size: 20 })
    ])
      .then(values => {
        this.supplier = values[0].data
        this.form = {
          name: values[0].data.name,
          payment_method: values[0].data.payment_method
        }

        this.table_orders_bank.items = values[1].data.results
        this.pagination_orders_bank.pages = values[1].data.pages
        this.pagination_orders_bank.count = values[1].data.count

        this.table_orders_cash.items = values[2].data.results
        this.pagination_orders_cash.pages = values[2].data.pages
        this.pagination_orders_cash.count = values[2].data.count

        this.table_products.items = values[3].data.results
        this.pagination_products.pages = values[3].data.pages
        this.pagination_products.count = values[3].data.count

        this.table_orders_payments.items = values[4].data.results
        this.pagination_orders_payments.pages = values[4].data.pages
        this.pagination_orders_payments.count = values[4].data.count

        this.is_loaded = true
      })
    getPaymentMethods().then(res => { this.payment_method_options = res.data })
    getBanks().then(response => { this.bank_options = response.data })
  },
  methods: {
    onPaymentCreate() {
      this.$v.payment_bank.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.$refs.submit.preload = true
        postSupplierPayments(this.$route.params.id, { orders: this.checked, note: this.payment_note, bank: this.payment_bank })
          .finally(() => { this.$refs.submit.preload = false })
          .then(() => {
            getSupplierProduct(this.$route.params.id).then(res => { this.supplier = res.data })
            this.fetchOrdersBank()
            this.fetchPayments()
            this.checked_all = false
            this.checked = []
            this.payment_note = ''
            this.payment_bank = ''
            this.$modal.hide('create-payment')
            this.$notify({
              type: 'success',
              title: 'Payment created',
            })
          })
      }
    },
    orderList(orders) {
      let result = ''
      for (const key in orders) {
        result += `ID: ${orders[key].id} - ${this.dateFormat(orders[key].date)}<br>`
      }
      return result
    },
    onFilterChange() {
      this.fetchOrdersBank()
    },
    onDownloadInvoice(invoice, id) {
      axios.get(invoice.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = invoice.file_name.split('.').pop()
          link.href = url
          link.setAttribute('download', `Invoice ${this.supplier.name} - Order ${id}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchOrdersBank() {
      getOrdersProduct({
        page: this.pagination_orders_bank.page,
        page_size: 20,
        supplier: this.$route.params.id,
        payment_method: 'bank',
        is_paid: this.filter
      }).then(res => {
        this.table_orders_bank.items = res.data.results
        this.pagination_orders_bank.pages = res.data.pages
        this.pagination_orders_bank.count = res.data.count
        this.table_bank_preloader = false
      })
    },
    fetchOrdersCash() {
      getOrdersProduct({
        page: this.pagination_orders_cash.page,
        page_size: 20,
        supplier: this.$route.params.id,
        payment_method: 'cash'
      }).then(res => {
        this.table_orders_cash.items = res.data.results
        this.pagination_orders_cash.pages = res.data.pages
        this.pagination_orders_cash.count = res.data.count
        this.table_cash_preloader = false
      })
    },
    fetchProducts() {
      getProductsProductstorage({
        page: this.pagination_products.page,
        page_size: 20,
        suppliers: [this.$route.params.id]
      }).then(res => {
        this.table_products.items = res.data.results
        this.pagination_products.pages = res.data.pages
        this.pagination_products.count = res.data.count
        this.table_product_preloader = false
      })
    },
    fetchPayments() {
      getSupplierPayments(
        this.$route.params.id,
        {
          page: this.pagination_orders_payments.page,
          page_size: 20
        })
        .then(res => {
          this.table_orders_payments.items = res.data.results
          this.pagination_orders_payments.pages = res.data.pages
          this.pagination_orders_payments.count = res.data.count
          this.table__payments_preloader = false
        })
    },
    onClickPaginationOrderBank(page) {
      this.table_bank_preloader = true
      this.pagination_orders_bank.page = page
      this.fetchOrdersBank()
    },
    onClickPaginationOrderCash(page) {
      this.table_cash_preloader = true
      this.pagination_orders_cash.page = page
      this.fetchOrdersCash()
    },
    onClickPaginationProduct(page) {
      this.table_product_preloader = true
      this.pagination_products.page = page
      this.fetchProducts()
    },
    onClickPaginationPayments(page) {
      this.table_payments_preloader = true
      this.pagination_orders_payments.page = page
      this.fetchPayments()
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit_info.preload = true
      const data = {
        name: this.form.name,
        payment_method: this.form.payment_method.code
      }
      patchProductStorageSupplier(this.$route.params.id, data)
        .finally(() => { this.$refs.submit_info.preload = false })
        .then(() => {
          getSupplierProduct(this.$route.params.id)
            .then(response => {
              this.supplier = response.data
            })
          this.$notify({
            type: 'success',
            title: 'Supplier edited',
          })
        })
    },
  }
}
</script>
<style lang="sass" scoped>
.slide-small-enter-active
  transition-duration: 0.3s
  transition-timing-function: ease-in

.slide-small-leave-active
  transition-duration: 0.3s
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1)

.slide-small-enter-to, .slide-small-leave
  max-height: 147px
  overflow: hidden

.slide-small-enter, .slide-small-leave-to
  overflow: hidden
  max-height: 0
</style>
